import { parseJSON } from 'date-fns';
import {
    Avatar,
    Card,
    CardContent,
    CardHeader,
    Stack,
    Typography,
} from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers';

import { TripleColumnLayout } from '@barboxx/admin-components';
import { Order } from '@barboxx/models';
import { getInitials } from '@barboxx/utils';

import { BaseTextInput } from './BaseTextInput';

export function TabDetailsCard({ order }: { order: Order.DetailsResponse }) {
    const initials = getInitials(order.customer);

    return (
        <Card>
            <CardHeader title="Tab Details" />
            <CardContent>
                <TripleColumnLayout
                    LeftContent={
                        <Stack gap={2}>
                            <BaseTextInput label="Tab Id" value={order.id} />
                            <BaseTextInput
                                label="Business"
                                value={order.business.place?.name}
                            />
                            <BaseTextInput
                                label="Status"
                                value={order.status}
                            />
                            <DateTimePicker
                                label="Created At"
                                value={parseJSON(order.createdAt)}
                                format="MM/dd/yyyy hh:mm:ss aa"
                                readOnly
                            />
                            <DateTimePicker
                                label="Completed At"
                                value={
                                    order?.completedAt
                                        ? parseJSON(order.completedAt)
                                        : undefined
                                }
                                format="MM/dd/yyyy hh:mm:ss aa"
                                readOnly
                            />
                        </Stack>
                    }
                    CenterContent={
                        <Stack gap={2} flex={1}>
                            <Avatar
                                sx={{
                                    width: '15rem',
                                    height: '15rem',
                                    alignSelf: 'center',
                                }}
                                alt="Customer photo"
                                src={order.customer?.avatar ?? ''}
                            >
                                {initials && (
                                    <Typography fontSize="8rem" variant="h6">
                                        {initials}
                                    </Typography>
                                )}
                            </Avatar>
                            <BaseTextInput
                                label="First Name"
                                value={order.customer.firstName}
                            />
                            <BaseTextInput
                                label="Last Name"
                                value={order.customer.lastName}
                            />
                            <BaseTextInput
                                label="Display Name"
                                value={order.customer.displayName}
                            />
                        </Stack>
                    }
                    RightContent={
                        <Stack gap={2}>
                            <BaseTextInput
                                label="Customer Id"
                                value={order.customerId}
                            />
                            <BaseTextInput
                                label="Locker"
                                value={order.locker?.name ?? order.lockerId}
                            />
                            {order.cubbyId != null && (
                                <BaseTextInput
                                    label="Cubby"
                                    value={order.cubbyId}
                                />
                            )}
                            <BaseTextInput
                                label="Started At"
                                value={order.startedAt ?? 'N/A'}
                            />
                            <BaseTextInput
                                label="Ready At"
                                value={order.readyAt ?? 'N/A'}
                            />
                            <BaseTextInput
                                label="Employee Id"
                                value={order.employeeId ?? 'N/A'}
                            />
                        </Stack>
                    }
                />
            </CardContent>
        </Card>
    );
}
